// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__gvATM","btnDelete":"Button_btnDelete__KcnXz","btnEdit":"Button_btnEdit__lqQK8","btnBack":"Button_btnBack__EVw0I"};